/* eslint-disable @typescript-eslint/no-explicit-any */
import SEOLocaleList from '@apps/components/SEOLocaleList';
import { BASE_URL } from '@apps/config';
import { getAllEvOverview } from '@apps/config/API/new-car.config';
import EvOverviewScreen from '@apps/screens/EvOverviewScreen';
import createBasePath from '@stack/helpers/lib/createBasePath';
import { Breadcrumb } from '@stack/ui';
import { BreadCrumbOptions } from '@stack/ui/components/Breadcrumb/props';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { NextSeo, NextSeoProps } from 'next-seo';

/**
 * ===========================
 * MAIN
 * ===========================
 */
const Page: NextPage = (props) => {
  const { webView, evOverview } = props;

  // ============ HOOKS
  const router = useRouter();
  const { basePath } = createBasePath({ webView, type: 'cars' });
  const breadcrumbOpt: BreadCrumbOptions[] = [
    {
      title: 'AutoFacts',
      url: `${basePath === '' ? '/' : basePath}`,
    },
    {
      title: 'EV Overview',
      url: ``,
    },
  ];

  // ======================= VARIABLES
  const currentUrl = `${BASE_URL}${router?.asPath}`;
  const canonicalPath = currentUrl.split('?')[0].toLowerCase();
  const nextSeoProps: NextSeoProps = {
    defaultTitle:
      'Electric Cars in Malaysia: EV Models, Specs & Prices | Carz Automedia Malaysia',
    description:
      'Explore all electric cars available in Malaysia. EV Overview models, specifications, features, and prices to find the perfect electric vehicle for your needs with Carz Automedia Malaysia.',
    canonical: canonicalPath,
  };

  // ============ VIEWS
  return (
    <>
      {!webView && <NextSeo {...nextSeoProps} />}
      <SEOLocaleList />
      {!webView && <Breadcrumb options={breadcrumbOpt} bold />}
      <EvOverviewScreen evOverview={evOverview} webView={webView} />
    </>
  );
};

/**
 * ===========================
 * SERVER SIDE RENDERING
 * ===========================
 */
export async function getServerSideProps(ctx: any) {
  const ids = ctx?.req?.cookies?.pinned ?? '';
  let idList;
  try {
    idList = JSON.parse(decodeURIComponent(ids)); // Safely decode and parse the cookie
  } catch (e) {
    console.error('Failed to parse pinned cookie:', e);
    idList = []; // Fallback to an empty array if parsing fails
  }

  const evOverview = await getAllEvOverview({
    ids: idList.join(','),
  });

  return {
    props: {
      evOverview,
    },
  };
}

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default Page;
